<template>
	<div id="dynvibeSearchFiltersBase" class="col-lg-6">
		<input class="dynvibeSearchInputSearch" placeholder="SEARCH FOR..." type="text" @keyup.enter="searchPost($event)" />
		<select id="dynvibeListPanels" class="listPanels dynvibeListPanels" v-model="profiles.panel">
			<option value="">Panels</option>
			<option v-for="(panel, index) in panels" :key="index" :value="panel._source.label">{{ panel._source.label }}</option>
		</select>
		<select id="dynvibeListSegments" class="listSegments dynvibeListSegments" v-model="profiles.segment">
			<option value="">Segments</option>
			<option v-for="(segment, index) in segmentsAll" :key="index" :value="segment._source.label">
				{{ segment._source.label }}
			</option>
		</select>
		<select id="dynvibeListSort" class="listSort dynvibeListSort" @change="updateSort($event.target.value)">
			<option value="latest_published">Latest {{ profilesPage == true ? "Modified" : "Published" }}</option>
			<option value="oldest_published">Oldest {{ profilesPage == true ? "Modified" : "Published" }}</option>
			<option value="impact_score">Impact score</option>
			<option v-if="profilesPage != true" value="authors">Profiles</option>
		</select>
		<select
			id="dynvibeSelectSize"
			class="dynvibeSelect"
			name="items"
			style="color: #ef402e; background-color: #f9e7e6"
			v-model="profiles.size"
		>
			<option value="">Per page</option>
			<option value="20">20</option>
			<option value="50">50</option>
			<option value="100">100</option>
			<option value="500">500</option>
		</select>
		<input
			type="text"
			id="dynvibe_impact_score_max"
			name="impactScoreMax"
			placeholder="Follower Max"
			class="PanelAuthorSearchSelector"
			onkeypress="return event.charCode >= 48 && event.charCode <= 57"
			v-model.lazy="profiles.impact_score_max"
		/>
		<input
			type="text"
			id="dynvibe_impact_score_min"
			name="impactScoreMin"
			placeholder="Follower Min"
			class="PanelAuthorSearchSelector"
			onkeypress="return event.charCode >= 48 && event.charCode <= 57"
			v-model.lazy="profiles.impact_score_min"
		/>
	</div>
	<div v-if="displayCheckBoxesFilter" id="dynvibeSearchFiltersActive" class="col-lg-2">
		<div class="dynvibeFilters">
			<div>
				<label class="checkbox">
					<input
						type="checkbox"
						class="dynvibeProfiles"
						value="all"
						id="all-checkbox-filters"
						v-model="profiles.checkbox_all"
						@click="
							setChecked($event);
							checkboxAll($event);
						"
					/>
					<span>ALL</span>
				</label>
			</div>
			<div>
				<label class="checkbox">
					<input
						type="checkbox"
						class="dynvibeProfiles"
						value="checked"
						v-model="profiles.is_checked"
						@click="setChecked($event)"
					/>
					<span>CHECKED</span>
				</label>
			</div>
			<div>
				<label class="checkbox">
					<input
						type="checkbox"
						class="dynvibeProfiles"
						value="unchecked"
						v-model="profiles.is_checked"
						@click="setChecked($event)"
					/>
					<span>UNCHECKED</span>
				</label>
			</div>
			<div>
				<label class="checkbox">
					<input
						type="checkbox"
						class="dynvibeProfiles"
						value="no_segment"
						v-model="profiles.no_segment"
						@click="setChecked($event)"
					/>
					<span>UNAFFECTED TO SEGMENT</span>
				</label>
			</div>
		</div>
	</div>

	<div v-if="displayCheckBoxesMastertag" class="col-lg-2" style="padding-top: 5px">
		<label class="labelRadio"
			>ALL
			<input type="radio" v-model="mastertagged" value="All" @click="mastertagged = 'All'" />
			<span class="checkmark"></span>
		</label>

		<label class="labelRadio"
			>MASTERTAGGED
			<input type="radio" v-model="mastertagged" value="mastertagged" @click="mastertagged = 'mastertagged'" />
			<span class="checkmark"></span>
		</label>

		<label class="labelRadio"
			>NOT MASTERTAGGED
			<input type="radio" v-model="mastertagged" value="notmastertagged" @click="mastertagged = 'notmastertagged'" />
			<span class="checkmark"></span>
		</label>
	</div>

	<div class="col-lg-3" v-if="profilesPage == true">
		<span data-action="add" class="dynvibeButton dynvibeModalAuthor" @click="addNewAuthor()">Add new author</span>
		<!-- <span class="dynvibeButton dynvibeFollowing">Download Authors Following</span> -->
		<span class="dynvibeButton dynvibeLocation" @click="downloadLocation()">Download Authors Location</span>
		<div id="profilessegmentsuploader" class="fileuploader btn btn-primary mr-2">
			<i class="fas fa-folder"></i> Upload segments
			<input type="file" title="Click to add Files" id="uploadSegment" @change="uploadSegments" />
		</div>
		<span class="dynvibeSearchInputResetFilters" title="Reset filters" @click="resetFilters()">Reset Filters</span>
	</div>
	<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType">
		<template v-slot:confirm-body>{{ confirmMessage }}</template>
	</confirm>
</template>

<script>
import confirm from "@/components/globalVue/Confirm.vue";

export default {
	name: "middlefilter",
	props: {
		profilesPage: {
			type: Boolean,
			default: false,
		},
		displayCheckBoxesFilter: {
			type: Boolean,
			default: true,
		},
		displayCheckBoxesMastertag: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["changefilters", "addnewauthor"],
	components: {
		confirm: confirm,
	},
	data() {
		return {
			segments: "",
			segmentsAll: "",
			panels: "",
			interests: "",
			uploadFile: [],
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
			profiles: {
				search: "",
				panel: "",
				segment: "",
				sort: {
					field: "date",
					order: "desc",
				},
				size: 20,
				impact_score_min: "",
				impact_score_max: "",
				checkbox_all: false,
				is_checked: [],
				no_segment: false,
			},
			mastertagged: "All",
			resetFiltersEvent: false,
		};
	},
	mounted: function () {},
	methods: {
		loadComponent() {
			this.getData("filtersMiddle");
		},
		treatResponse(response) {
			this.segments = response.data.segments;
			this.segmentsAll = response.data.segmentsAll;
			this.panels = response.data.panels;
		},
		searchPost(event) {
			this.profiles.search = event.target.value;
		},
		// Necessary because v-model can't be used with the dynvibeProfiles CSS structure :(
		setChecked: function (event) {
			let target = event.target;
			if (target.checked == true) {
				let elt = document.getElementsByClassName("dynvibeProfiles");
				// 'All' checkbox case
				if (target.value == "all") {
					for (let i = 0; i < elt.length; i++) {
						elt[i].setAttribute("checked", "checked");
					}
				} else {
					target.setAttribute("checked", "checked");

					let checkboxAll = document.getElementById("all-checkbox-filters");
					checkboxAll.setAttribute("checked", "checked");

					for (let i = 1; i < elt.length; i++) {
						if (!elt[i].getAttribute("checked") || elt[i].getAttribute("checked") == "false") {
							checkboxAll.setAttribute("checked", false);
							this.profiles.checkbox_all = false;
						}
					}
				}
			} else {
				// 'All' checkbox case
				if (target.value == "all") {
					let elt = document.getElementsByClassName("dynvibeProfiles");
					for (let i = 0; i < elt.length; i++) {
						elt[i].setAttribute("checked", false);
					}
				} else {
					target.setAttribute("checked", false);
					let checkboxAll = document.getElementById("all-checkbox-filters");
					checkboxAll.setAttribute("checked", false);
					this.profiles.checkbox_all = false;
				}
			}
		},
		checkboxAll: function (event) {
			if (event.target.checked == false) {
				this.profiles.checkbox_all = false;
				this.profiles.is_checked = [];
				this.profiles.no_segment = false;
			} else {
				this.profiles.checkbox_all = true;
				this.profiles.is_checked = ["checked", "unchecked"];
				this.profiles.no_segment = true;
			}
		},
		resetFilters(noreload = false) {
			this.resetFiltersEvent = true;

			this.profiles = {
				search: "",
				panel: "",
				segment: "",
				sort: {
					field: "date",
					order: "latest_published",
				},
				size: 20,
				impact_score_min: "",
				impact_score_max: "",
				checkbox_all: false,
				is_checked: [],
				no_segment: false,
				no_source: false,
			};
			let elt = document.getElementsByClassName("dynvibeProfiles");
			for (let i = 0; i < elt.length; i++) {
				elt[i].setAttribute("checked", false);
			}
			let following = document.getElementsByClassName("PanelAuthorSearchSelector");
			for (let i = 0; i < following.length; i++) {
				following[i].value = "";
			}
			document.getElementsByClassName("dynvibeSearchInputSearch")[0].value = "";
			if (noreload == false) {
				this.changeFilters();
			}
		},
		prepareParameters() {
			let p = {};
			p.type = "Profiles";
			p.sort = {
				field: "date",
				order: "asc",
			};

			this.profiles.search !== "" ? (p.search = this.profiles.search) : false;
			this.profiles.panel !== "" ? (p.panel = this.profiles.panel) : false;
			this.profiles.segment !== "" ? (p.segment = this.profiles.segment) : false;
			/*if (this.profiles.sort.field === "authors") {
                p.orderBy = "profiles";
                delete p.sort;
            } else {
                p.sort = this.profiles.sort;
                delete p.orderBy;
            }*/

			p.size = this.profiles.size !== "" ? parseInt(this.profiles.size) : 20;

			p.impact_score = {
				gt: this.impact_score_min,
				lt: this.impact_score_max,
			};
			this.profiles.impact_score_max == "" ? delete p.impact_score.lt : false;
			this.profiles.impact_score_min == "" ? delete p.impact_score.gt : false;

			p.is_checked = this.profiles.is_checked;

			this.profiles.no_segment == true ? (p.no_segment = true) : false;

			p.is_checked.length < 1 ? delete p.is_checked : false;

			return p;
		},
		downloadLocation() {
			let p = this.prepareParameters();
			this.confirmLoadingModal("open");

			this.$axios.post(this.$backendUrl + "getLocation", this.$Qs.stringify(p)).then(
				(response) => {
					this.confirmLoadingModal();
					if (response) {
						let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + response.data.map((e) => e.join(";")).join("\n");
						let encodedUri = encodeURI(csvContent);
						let link = document.createElement("a");
						link.setAttribute("href", encodedUri);
						link.setAttribute("download", "Location.csv");
						document.body.appendChild(link); // Required for FF

						link.click();
					} else {
						this.confirmErrorModal("FAIL : Unable to download Excel files");
					}
				},
				() => {
					this.confirmErrorModal("FAIL");
				}
			);
		},
		downloadInfluencers() {
			let p = this.prepareParameters();
			this.confirmLoadingModal("open");

			this.$axios.post(this.$backendUrl + "getInfluencersSegment", this.$Qs.stringify(p)).then(
				(response) => {
					this.confirmLoadingModal();
					if (response.data.isOk) {
						window.open(this.$backendUrl + "/uploads/" + response.data.file);
					} else {
						this.confirmErrorModal("Problem getting the file contact IT Team");
					}
				},
				() => {
					this.confirmErrorModal("FAIL");
				}
			);
		},
		uploadSegments(e) {
			let fileInput = document.getElementById("uploadSegment");
			let filePath = fileInput.value;
			let allowedExtensions = /(\.csv)$/i;
			if (!allowedExtensions.exec(filePath)) {
				this.confirmErrorModal("FAIL : Only csv file is authorized");
			} else {
				this.confirmLoadingModal("open");
				let formData = new FormData();
				formData.append("fileupload", e.target.files[0]);
				formData.append("idUploader", "profilessegmentsuploader");

				this.$axios.post(this.$backendUrl + "fileupload", formData).then(
					(response) => {
						if (response.data.error != "") {
							this.confirmErrorModal("FAIL : " + response.data.error);
						} else {
							this.confirmSuccessModal("File has been added.");
						}
					},
					() => {
						this.confirmErrorModal("File has not been added.");
					}
				);
			}
			document.getElementById("uploadSegment").value = "";
			return false;
		},
		changeFilters() {
			if (this.profiles.sort.field === "date") {
				let prefix = "post_";
				if (this.profilesPage) {
					prefix = "profile_";
				}
				this.profiles.sort.field = prefix + this.profiles.sort.field;
			}
			if (this.displayCheckBoxesMastertag) {
				this.$emit("changefilters", {
					profiles: this.profiles,
					mastertagged: this.mastertagged,
				});
			} else {
				this.$emit("changefilters", this.profiles);
			}
		},
		addNewAuthor() {
			this.$emit("addnewauthor");
		},
		updateSort(sort) {
			let prefix = "post_";
			if (this.profilesPage) {
				prefix = "profile_";
			}
			if (sort === "oldest_published") {
				this.profiles.sort = {
					field: prefix + "date",
					order: "asc",
				};
			} else if (sort === "latest_published") {
				this.profiles.sort = {
					field: prefix + "date",
					order: "desc",
				};
			} else if (sort === "impact_score") {
				this.profiles.sort = {
					field: "post_impact_score",
					order: "desc",
				};
			} else if (sort === "authors") {
				this.profiles.sort = {
					field: "authors",
					order: "desc",
				};
			}
		},
	},
	watch: {
		profiles: {
			handler() {
				if (this.resetFiltersEvent == false) {
					this.changeFilters();
				}
				this.resetFiltersEvent = false;
			},
			deep: true,
		},
		mastertagged() {
			this.changeFilters();
		},
	},
};
</script>

<style scoped>
.PanelAuthorSearchSelector::placeholder,
.dynvibeSearchInputSearch::placeholder {
	color: #8e8e8e;
}

.labelRadio {
	display: block;
	position: relative;
	padding-left: 25px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #8e8e8e;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelRadio input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 15px;
	width: 15px;
	background-color: #fff;
	border-radius: 50%;
	border: 1px solid #33d1cd;
}

/* On mouse-over, add a grey background color */
.labelRadio:hover input ~ .checkmark {
	background-color: rgba(51, 209, 205, 0.2);
}

/* When the checkbox is checked, add a blue background */
.labelRadio input:checked ~ .checkmark {
	background-color: #33d1cd;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

/* Show the checkmark when checked */
.labelRadio input:checked ~ .checkmark:after {
	display: block;
}
</style>
